import styled, { css } from 'styled-components'
import { Link as RouterLink } from 'react-router-dom';

export const BreadcrumbContainer = styled.div`
  display: flex;

  align-items: center;
  gap: 8px;
  font-size: 14px;
  margin-bottom: 24px;
  
  @media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
    display: none;
  }
`

export const Link = styled(RouterLink)`
  text-decoration: none;
  color: ${props => props.theme.colors.brand.selectGreen};
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  transition: color 0.2s ease;
  
  ${props =>
    props.current &&
    css`
      color: ${props => props.theme.colors.black};
      font-weight: 400;
      pointer-events: none;
      cursor: default;
    `}

  &:hover {
    ${props =>
      !props.current &&
      css`
        color: ${props => props.theme.colors.brand.selectGreen};
      `}
  }

  &:focus {
    color: ${props => props.theme.colors.brand.selectGreen};
    outline: none;
  }
`

export const Span = styled.span`
  font-size: 14px;
  display: inline-flex;
  align-items: center;
`

export const SeparateSpan = styled.span`
  color: ${props => props.theme.colors.black};
  font-weight: 400;
  user-select: none;
  margin: 0 8px;
`